module.exports = __webpack_public_path__ + "img/BRA.76c8a904.svg";